export const BookingTicketTypes = {
  Departure: "departure",
  Return: "return",
} as const;

export type BookingTicketType =
  (typeof BookingTicketTypes)[keyof typeof BookingTicketTypes];
